import { jsx as _jsx } from "react/jsx-runtime";
import ArrowForwardRoundedIcon_ from "@mui/icons-material/ArrowForwardRounded.js";
import NorthEastIcon_ from "@mui/icons-material/NorthEast.js";
import { normalizeIcon } from "../helpers/normalizeIcon.js";
import { EnableAutoWrapPreview } from "./EnableAutoWrapPreview.js";
import { SubscribePreview } from "./SubscribePreview.js";
import { WrapIntoSuperTokensPreview } from "./WrapIntoSuperTokensPreview.js";
export const NorthEastIcon = normalizeIcon(NorthEastIcon_);
export const UpgradeIcon = normalizeIcon(ArrowForwardRoundedIcon_);
export function CommandPreview({ command: cmd }) {
    switch (cmd.type) {
        case "Wrap into Super Tokens":
            return _jsx(WrapIntoSuperTokensPreview, { command: cmd });
        case "Enable Auto-Wrap":
            return _jsx(EnableAutoWrapPreview, { command: cmd });
        case "Subscribe":
            return _jsx(SubscribePreview, { command: cmd });
    }
}
